import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

let $=jQuery.noConflict();
export class ZIDXSearchEmbedView implements ZIDXPage {
    static loadMoreIntervalId:any=0;
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxSearchEmbedViewContainer";
    }


    render() {
        // console.log("site home");
        let self=this;
        this.zidx.zidxBase.resetForNavigation();
        this.zidx.zidxBase.init(false, false, false, false)
        if(ZIDXSearchEmbedView.loadMoreIntervalId!=0){
            clearInterval(ZIDXSearchEmbedView.loadMoreIntervalId);
        }
        let startTime=Date.now();
        let loadMoreIntervalId=setInterval(function(){
            if(Date.now()-startTime>30000){
                clearInterval(loadMoreIntervalId);
                return;
            }
            if(window.location.href.indexOf("loadMore=1")!=-1){
                let loadMoreButton=$(".zidxLoadMoreButton", self.zidx.peakidxShadowRoot);
                if(loadMoreButton.length>0) {
                    let rect = loadMoreButton[0].getBoundingClientRect();
                    // scroll to top of rect
                    window.scrollTo(0, rect.top - 200);
                    loadMoreButton.trigger("click");
                    clearInterval(loadMoreIntervalId);
                }
            }
        }, 100);
        ZIDXSearchEmbedView.loadMoreIntervalId=loadMoreIntervalId;
    }
}